<template>
  <v-btn v-if="!hide" @click="print" :icon="icon" :small="small" :disabled="disabled">
    <v-icon>print</v-icon>
    <v-icon v-if="drink === true ">local_bar</v-icon>
    <v-icon v-if="drink === false ">lunch_dining</v-icon>
  </v-btn>
</template>

<script>

import {Dayjs} from '@dracul/dayjs-frontend'
import CategoryMixin from "@/modules/delivery/mixins/CategoryMixin";

export default {
  name: "PrintTicket",
  props: {
    order: {type: Object, required: true},
    hide: {type: Boolean, default: false},
    icon: {type: Boolean, default: true},
    small: {type: Boolean, default: true},
    disabled: {type: Boolean, default: false},
    drink: {type: Boolean, default: null},
  },
  mixins: [CategoryMixin],
  computed: {
    isBar(){
      return (this.order.origin === 'BAR' && this.order.delivery.timeMode === 'AS_SON_AS_POSIBLE' && this.order.delivery.mode === 'TAKE_AWAY')
    },
    getRangeScheduleTime() {
      return this.$store.getters.getSetting('RangeScheduleTime').value
    },
    getTime() {
      if (this.order.delivery.mode === 'DELIVERY' && this.order.delivery.time) {
        let hour = Dayjs(this.order.delivery.time, "HH:mm")
        let text
        if (this.order.delivery.timeMode === 'AS_SON_AS_POSIBLE') {
          text = hour.format("HH:mm")
        } else {
          let hourTo = hour.add(this.getRangeScheduleTime, 'm')
          text = hour.format("HH:mm") + " a " + hourTo.format("HH:mm")
        }

        return text
      } else {
        return this.order.delivery.time
      }
    },
    contentZona() {
      let contentZona = ''
      if (this.order.zoneName) {
        contentZona += `<br><span style="font-weight: bold;">Zona:</span><span>${this.order.zoneName}</span>`
      }
      return contentZona
    },
    getAddress() {
      let address = this.order.location.address
      if (/,/.test(this.order.location.address)) {
        address = this.order.location.address.split(",")[0]
      }
      return address
    },
    items() {
      return this.order.items
    },
    paymentMethod() {
      let contentPaymentMethod = ''
      let method = this.$t('delivery.payment.method.' + this.order.payment.method)
      contentPaymentMethod += `<br><span  style="font-weight: bold;">Pago: </span><span>${method}</span>`
      return contentPaymentMethod
    },
    contentContact() {
      let contentContact = ''
      if (this.order.delivery.mode === 'TAKE_AWAY') {
        contentContact += `<br><span  style="font-weight: bold;">Nombre:</span><span> ${this.order.contact.name}</span>`
      }
        contentContact += `<br><span style="font-weight: bold;">Tel: </span><span>${this.order.contact.phone ? this.order.contact.phone : ''}</span>`
        contentContact += `<br><span style="font-weight: bold;">Obs: </span><span>${this.order.contact.observations ? this.order.contact.observations : ''}</span>`
      return contentContact
    },
    contentAddress() {
      let contentAddress = ''
      if (this.order.delivery.mode === 'DELIVERY') {
        contentAddress += `<br><span style="font-weight: bold;">Dirección: </span><span>${this.getAddress}</span>`
        if (this.order.location.floor || this.order.location.apartment) {
          contentAddress += `<br><span style="font-weight: bold;">Piso/Dpto: </span><span>${this.order.location.floor + this.order.location.apartment}</span>`
        }
      }
      return contentAddress
    },
    contentDeliveryTime() {
      return `<br><span  style="font-weight: bold;">Hora: </span><span>${this.getTime}</span>`
    },
    getFilteredCategories() {
      switch(this.drink){
        case true:
          return this.getItemsCategories.filter(c => c.drink === true)
        case false:
          return this.getItemsCategories.filter(c => c.drink === false)
        default:
          return this.getItemsCategories
      }
    },


    tableItems() {
      let table = ''
      let totalQuantity = 0
      let totalAmount = 0


      if(this.order.promos.length > 0){
        table += `<tr><th colspan="3" style="border-top: 1px solid grey">PROMOS (x${this.order.promos.length})</th></tr>`

      }


      for (let orderPromo of this.order.promos) {
        table += `<tr>
          <th colspan="2" style="border-top: 1px solid grey">${orderPromo.promo.name}</th>
          <td style="text-align: right;font-size: 18px"">$${orderPromo.price}</td>
        </tr>`
        totalAmount += orderPromo.price
        for (let item of orderPromo.items) {
          totalQuantity += item.quantity
          table += `<tr>
                    <td style="text-align: center;font-size: 18px">${item.quantity}</td>
                    <td colspan="2" style="text-align: left;">${item.product.name}</td>
                   </tr>`
        }
      }


      for (let category of this.getFilteredCategories) {
        table += `<tr><th colspan="3" style="border-top: 1px solid grey">${category.name.toUpperCase()} (x${this.getItemsQuantityByCategory(category)})</th></tr>`

        for (let item of this.getItemsByCategory(category)) {
          totalQuantity += item.quantity
          totalAmount += item.amount
          table += `<tr>
                    <td style="text-align: center;font-size: 18px">${item.quantity}</td>
                    <td style="text-align: left;">${item.product.name}</td>
                    <td style="text-align: right;font-size: 18px"">$${item.amount}</td>
                   </tr>`
        }

      }

      table += `<tr >
                  <th style="text-align: center; border-top: 1px solid grey">${totalQuantity}</th>
                  <th style="text-align: center; border-top: 1px solid grey">Subtotal</th>
                  <th style="text-align: right; border-top: 1px solid grey">$${totalAmount}</th>
                </tr>`

      if (this.order.delivery.mode === 'DELIVERY' && this.order.delivery.cost && this.order.deliveryFree === false) {
        totalAmount += this.order.delivery.cost
        table += `<tr>
                    <td style="border-top: 1px solid grey"></td>
                    <td style="text-align: center;border-top: 1px solid grey">COSTO DE ENVIO</td>
                    <td style="text-align: right;border-top: 1px solid grey">$${this.order.delivery.cost}</td>
                   </tr>`
      }

      if (this.order.totalDiscount > 0) {
        totalAmount -= this.order.totalDiscount
        table += `<tr>
                    <td style="border-top: 1px solid grey"></td>
                    <td style="text-align: center;border-top: 1px solid grey">Descuento</td>
                    <td style="text-align: right;border-top: 1px solid grey">-$${this.order.totalDiscount}</td>
                   </tr>`
      }

      table += `<tr >
                  <th style="text-align: center; border-top: 1px solid grey">${totalQuantity}</th>
                  <th style="text-align: center; border-top: 1px solid grey">TOTAL</th>
                  <th style="text-align: right; border-top: 1px solid grey">$${totalAmount}</th>
                </tr>`
      return table
    },
    isVoucherPending(){
      return ( ['BANK_TRANSFER','MP_TRANSFER'].includes(this.order.payment.method) && this.order.payment.receiptFile === null && !this.order.payment.confirmed )
    },
    getDeliveryMode(){
      if (this.order.delivery.mode === 'TAKE_AWAY' && this.isBar){
        return 'MOSTRADOR'
      }else if(this.order.delivery.mode === 'DELIVERY' && this.order.delivery.longDistance ){
        return 'DELIVERY (LG)'
      }
      return this.order.delivery.mode
    }
  },
  methods: {
    getDate() {
      return Dayjs().format("DD-MM-YYYY")
    },
    print() {
      let printPreview = window.open('', 'print_preview');
      let printDocument = printPreview.document;
      printDocument.open();

      let head =
          "<head>" +
          "<style> .to-print{height:279mm; width:80mm; } </style>" +
          "</head>";

      let contentOrderNumber = `<div style="font-size: 20px; font-weight: bold; text-align: center">ORDEN ${this.order.number}</div>`
      let contentOrigin = (this.isBar ? `<div style=" text-align: center">MOSTRADOR</div>` : '')
      let contentDrink = (this.drink === true ? `<div style=" text-align: center">BEBIDAS</div>` : '')
      let contentFood = (this.drink === false ? `<div style=" text-align: center">COMIDAS</div>` : '')
      let contentDate = `<span style="font-weight: bold;">Fecha: </span><span>${this.getDate()}</span>`
      let contentDelivery = `<br><span style="font-weight: bold;">Entrega: </span><span>${this.getDeliveryMode}</span>`
      let contentDeliveryMode = `<br><span style="font-weight: bold;">Modo: </span><span>${this.$t('delivery.mode.'+this.order.delivery.timeMode)}</span>`
      let pendingVoucher = this.isVoucherPending ? `<br><span style="font-weight: bold; font-style: italic">Comprobante pendiente!</span></span>` : ''
      let paymentConfirmed = this.order.payment.confirmed ? `<br><span style="font-weight: bold; font-style: italic">Pagado!</span></span>` : ''

      let content = `
      <!DOCTYPE html>
      <html>${head}<body>
      <div class='to-print'>
      <div style="font-size: 18px">
      ${contentOrderNumber}
      ${contentOrigin}
      ${contentDrink}
      ${contentFood}
      <br>
      ${contentDate}
      ${contentDelivery}
      ${contentDeliveryMode}
      ${this.contentDeliveryTime}

      ${this.contentContact}
      ${this.paymentMethod}
      ${pendingVoucher}
      ${paymentConfirmed}
      <br>
      ${this.contentZona}
      ${this.contentAddress}
      </div>
      <br>
      <hr>
      <table style="width: 100%;text-align: left; font-size: 16px">
        <thead>
          <tr>
            <th style="font-size: 14px">CANT</th>
            <th style="font-size: 14px">DESCRIPCIÓN</th>
            <th style="font-size: 14px; text-align: right">IMPORTE</th>
          </tr>
        </thead>
        <tbody>
        ${this.tableItems}
        </tbody>
      </table>
      <br><br><br><br><br>
      </div>
      </body></html>
      `



      printDocument.write(content);
      printPreview.print();
      printPreview.close()

    }
  }
}
</script>

<style scoped>

</style>
